(function(){
'use strict';
function cleanDesc(){
 document.querySelectorAll('.product__description p,.product__description li,.product__description div,.product__description br').forEach(function(el){
  if((el.textContent||'').trim()==='' && !el.querySelector('img')){ el.style.display='none'; }
 });
}
function eager(m){
 var c=m.querySelector('.product-media-modal__content'); if(!c) return;
 c.querySelectorAll('img').forEach(function(img){ img.loading='eager'; img.setAttribute('fetchpriority','high'); if(!img.complete){ var pl=new Image(); if(img.srcset)pl.srcset=img.srcset; if(img.src)pl.src=img.src; } });
}
/* Mobile product-page gallery position tracking.
   Drives the swipe chevron via data-cz-pos (start|mid|end) and data-cz-count.
   Scroll math alone is unreliable on a scroll-snap carousel (sub-pixel snapping,
   momentum scrolling, and iOS not firing a final scroll event), so an
   IntersectionObserver on the last slide is used as the authority for 'end'. */
function gal(){
 document.querySelectorAll('media-gallery').forEach(function(g){
  var slider=g.querySelector('.product__media-list'); if(!slider) return;
  var items=g.querySelectorAll('.product__media-item');
  g.setAttribute('data-cz-count',items.length);
  if(g.__czg) return; g.__czg=true;
  var lastVisible=false;
  function upd(){
   var max=slider.scrollWidth-slider.clientWidth;
   var end=lastVisible||(max>0&&slider.scrollLeft>=max-14);
   var st=slider.scrollLeft<=14;
   g.setAttribute('data-cz-pos',end?'end':(st?'start':'mid'));
  }
  slider.addEventListener('scroll',upd,{passive:true});
  slider.addEventListener('scrollend',upd);
  slider.addEventListener('touchend',function(){setTimeout(upd,140);},{passive:true});
  window.addEventListener('resize',upd);
  if(items.length>1&&'IntersectionObserver' in window){
   new IntersectionObserver(function(entries){
    entries.forEach(function(e){ lastVisible=e.isIntersecting&&e.intersectionRatio>=0.55; });
    upd();
   },{root:slider,threshold:[0,0.55,1]}).observe(items[items.length-1]);
  }
  [0,250,800].forEach(function(t){setTimeout(upd,t);});
 });
}
function stopAll(b){ ['pointerdown','pointerup','mousedown','mouseup','touchstart','touchend'].forEach(function(ev){ b.addEventListener(ev,function(e){e.stopPropagation();}); }); }
function mk(dir,act){
 var b=document.createElement('button');b.type='button';b.className='cz-arrow cz-arrow--'+dir;b.setAttribute('aria-label',dir==='next'?'Next image':'Previous image');b.innerHTML='<i></i>';b.hidden=true;
 b.addEventListener('click',function(e){e.stopPropagation();e.preventDefault();act();});
 stopAll(b);
 return b;
}
function modal(){
 var m=document.querySelector('product-modal.product-media-modal, .product-media-modal'); if(!m) return;
 var content=m.querySelector('.product-media-modal__content'); if(!content) return;
 if(!m.__czm){
  m.__czm=true;
  function page(dir){ content.scrollBy({left:dir*content.clientWidth}); setTimeout(function(){if(m.__czupd)m.__czupd();},40); }
  var prev=mk('prev',function(){page(-1);}); var next=mk('next',function(){page(1);});
  m.appendChild(prev); m.appendChild(next);
  m.__czupd=function(){var sc=content.scrollWidth-content.clientWidth>12;var end=content.scrollLeft+content.clientWidth>=content.scrollWidth-12;var st=content.scrollLeft<=12;next.hidden=!(sc&&!end);prev.hidden=!(sc&&!st);};
  content.addEventListener('scroll',m.__czupd,{passive:true}); window.addEventListener('resize',m.__czupd);
 }
 [60,300,700,1300].forEach(function(t){setTimeout(function(){if(m.__czupd)m.__czupd();},t);});
}
function init(){cleanDesc();gal();modal();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init); else init();
document.addEventListener('shopify:section:load',init);
var mo=new MutationObserver(function(){var m=document.querySelector('.product-media-modal'); if(m&&m.hasAttribute('open')){modal(); eager(m); if(m.__czupd){var c=m.querySelector('.product-media-modal__content'); if(c)c.scrollLeft=0; setTimeout(m.__czupd,60);}}});
mo.observe(document.documentElement,{attributes:true,subtree:true,attributeFilter:['open']});
})();